export default {
  headers: [
    ['satellite-tracking/report.start_time', 'startTime'],
    ['satellite-tracking/report.end_time', 'endTime'],
    ['satellite-tracking/report.retention_duration', 'retentionTime'],
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.driver_name', 'driver'],
    ['satellite-tracking/report.location_name', 'location']
  ]
}
